import { getModuleState as getEventInfoModuleState } from "../../selectors";

export const SAMPLE_SOIL_STATE_KEY = "SAMPLE_SOIL_STATE";

export const getModuleState = (state) => getEventInfoModuleState(state)[SAMPLE_SOIL_STATE_KEY];

export const getAutoTraceDefault = (state) => getModuleState(state).autoTraceDefault;

export const getUserDepthConfig = (state) => getModuleState(state).userDepthConfig;
